import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { Form } from "react-bootstrap";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import {
  add_hygiene_task,
  update_hygiene_task,
} from "../../../data/ApiEndpoints";
import { validationHygieneNewTaskForm } from "../hygiene-common/validation";
import {
  daysOfWeek,
  hygine_task_frequency_categories,
  months,
  TASK_PRIORITY,
} from "../../common-data/DropdowData";
import { currentDateOfTheMonth } from "../../common-data/Converts";
import SelectDropdown from "../../components-react/SelectDropdown";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import MultiSelect from "../../components-react/MultiSelect";
import TaskCategoryForm from "../categories/TaskCategoryForm";
import { fetchHygineTaskCategoryData } from "../../../redux/hygiene-reducers/hygieneSlice";
import "../../../styles/hydiene-system/hygiene-inputs.css";
import "../../../styles/hydiene-system/hygiene-tasks.css";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";
import moment from "moment-timezone";
import { ClockIconV3, Plus, RightArrowIcon } from "../../../images/icons/icons";

const TaskForm = ({
  userInfoData,
  callFunction,
  isEdit,
  rowData,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { hygineTaskCategory } = useSelector((state) => state.hygiene);

  const convertTimeToDropdownFormat = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    const hour24 = parseInt(hours, 10);
    const hour12 = hour24 % 12 || 12;
    const period = hour24 >= 12 ? "PM" : "AM";
    return {
      value: timeString,
      label: `${hour12}:${minutes} ${period}`,
    };
  };

  const parseTaskTimes = () => {
    if (!isEdit || !rowData?.task_times || !Array.isArray(rowData.task_times)) {
      return {
        timeSlots: [{ startTime: "", endTime: "" }],
        customDates: [{ date: "", startTime: "", endTime: "" }],
        isMultipleTimes: false,
      };
    }

    const frequencyType = rowData?.frequency_type;

    if (frequencyType === "custom") {
      const customDates = rowData.task_times.map((item) => ({
        date: item.date || "",
        startTime: convertTimeToDropdownFormat(item.start_time),
        endTime: convertTimeToDropdownFormat(item.end_time),
      }));
      return {
        timeSlots: [{ startTime: "", endTime: "" }],
        customDates:
          customDates.length > 0
            ? customDates
            : [{ date: "", startTime: "", endTime: "" }],
        isMultipleTimes: false,
      };
    } else {
      const timeSlots = rowData.task_times.map((item) => ({
        startTime: convertTimeToDropdownFormat(item.start_time),
        endTime: convertTimeToDropdownFormat(item.end_time),
      }));
      return {
        timeSlots:
          timeSlots.length > 0 ? timeSlots : [{ startTime: "", endTime: "" }],
        customDates: [{ date: "", startTime: "", endTime: "" }],
        isMultipleTimes: timeSlots.length > 1,
      };
    }
  };

  const parsedTimes = parseTaskTimes();

  const forminitials = {
    taskName: isEdit && rowData?.name ? rowData.name : "",
    selectedHygineCategory:
      isEdit && rowData?.category && rowData?.category_name
        ? {
            label: rowData.category_name,
            value: rowData.category,
          }
        : "",
    selectedTaskPriority:
      isEdit && rowData?.priority
        ? TASK_PRIORITY.find((item) => item?.value === rowData?.priority) || ""
        : "",
    isImage:
      isEdit &&
      typeof rowData?.media_type === "string" &&
      rowData.media_type.includes("image")
        ? true
        : false,
    isVideo:
      isEdit &&
      typeof rowData?.media_type === "string" &&
      rowData.media_type.includes("video")
        ? true
        : false,
    imageQuantity: isEdit && rowData?.img_quantity ? rowData.img_quantity : "",
    videoQuantity: isEdit && rowData?.vid_quantity ? rowData.vid_quantity : "",
    selectedAccountTypes:
      isEdit && rowData?.stakeholders
        ? rowData.stakeholders.split(",").map((stakeholder) => ({
            label: stakeholder.trim(),
            value: stakeholder.trim(),
          }))
        : [],
    selectedTaskFrequencyName:
      isEdit && rowData?.frequency_type
        ? hygine_task_frequency_categories.find(
            (item) => item?.value === rowData.frequency_type
          ) || ""
        : "",
    frequencyDays:
      isEdit && rowData?.week
        ? rowData.week.split(",").map((day) => day.trim())
        : [],
    frequencyDate:
      isEdit && rowData?.specific_date ? rowData.specific_date : "",
    selectedFrequencyInterval:
      isEdit && rowData?.hour
        ? {
            label: rowData.hour,
            value: rowData.hour,
          }
        : "",
    selectedMonth:
      isEdit && rowData?.month
        ? months.find((month) => month.value === String(rowData.month)) || ""
        : "",
    startTime: isEdit && rowData?.start_time ? rowData.start_time : "",
    endTime: isEdit && rowData?.end_time ? rowData.end_time : "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
    taskDescription: isEdit && rowData?.description ? rowData.description : "",

    scheduleDate:
      isEdit && rowData?.scheduled_date ? rowData.scheduled_date : "",
    isMultipleTimes: parsedTimes.isMultipleTimes,
    timeSlots: parsedTimes.timeSlots,
    customDates: parsedTimes.customDates,

    selectedRepeatEvery:
      isEdit && rowData?.incremental_value
        ? {
            label: `${rowData.incremental_value}`,
            value: parseInt(rowData.incremental_value, 10),
          }
        : "",
    selectedEndAfterTimes:
      isEdit && rowData?.end_after
        ? rowData.end_after === "-1"
          ? { label: "Never", value: "never" }
          : {
              label: `${rowData.end_after} times`,
              value: parseInt(rowData.end_after, 10),
            }
        : "",

    monthlyRangeStart:
      isEdit && rowData?.month_date_range
        ? rowData.month_date_range.includes(",")
          ? rowData.month_date_range.split(",")[0]?.trim() || ""
          : rowData.month_date_range.split("-").slice(0, 3).join("-") || ""
        : "",
    monthlyRangeEnd:
      isEdit && rowData?.month_date_range
        ? rowData.month_date_range.includes(",")
          ? rowData.month_date_range.split(",")[1]?.trim() || ""
          : rowData.month_date_range.split("-").slice(3).join("-") || ""
        : "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [taskCategories, setTaskCategories] = useState([]);

  const formRef = useRef({});

  const assignRef = (fieldName) => (el) => {
    if (!formRef.current) {
      formRef.current = {};
    }
    if (el) {
      formRef.current[fieldName] = el;
    }
  };

  const repeatEveryOptions = Array.from({ length: 99 }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1,
  }));

  const endAfterOptions = [
    { label: "Never", value: "never" },
    ...Array.from({ length: 99 }, (_, i) => ({
      label: `${i + 1} times`,
      value: i + 1,
    })),
  ];

  const timeOptions = Array.from({ length: 24 }, (_, i) => {
    const hour = i;
    const period = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 || 12;
    const time = `${displayHour}:00 ${period}`;
    const value = `${hour.toString().padStart(2, "0")}:00`;
    return {
      value: value,
      label: time,
    };
  });

  const getRepeatEveryLabel = () => {
    const freq = formValues.selectedTaskFrequencyName?.value;
    switch (freq) {
      case "daily":
        return "day";
      case "hourly":
        return "hour";
      case "weekly":
      case "weekend":
      case "week_days":
        return "week";
      case "monthly":
        return "month";
      case "yearly":
        return "year";
      default:
        return "time";
    }
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    if (name === "isMultipleTimes") {
      setFormValues((prev) => ({
        ...prev,
        [name]: checked,
        timeSlots: checked
          ? prev.timeSlots.length > 0
            ? prev.timeSlots
            : [{ startTime: "", endTime: "" }]
          : prev.timeSlots.length > 0
          ? [prev.timeSlots[0]]
          : [{ startTime: "", endTime: "" }],
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    if (name === "selectedTaskFrequencyName") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        scheduleDate: "",
        isMultipleTimes: false,
        timeSlots: [{ startTime: "", endTime: "" }],
        customDates: [{ date: "", startTime: "", endTime: "" }],
        monthlyRangeStart: "",
        monthlyRangeEnd: "",
        frequencyDays: [],
        selectedRepeatEvery: "",
        selectedEndAfterTimes: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCheckboxChange = (dayValue) => {
    setIsSubmit(false);

    setFormValues((prev) => {
      const isDaySelected = prev.frequencyDays.includes(dayValue);
      return {
        ...prev,
        frequencyDays: isDaySelected
          ? prev.frequencyDays.filter((d) => d !== dayValue)
          : [...prev.frequencyDays, dayValue],
      };
    });
  };

  function getHygieneTaskCategories() {
    const filters = {
      status: "active",
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchHygineTaskCategoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  // ---------------- custom functions ----------------
  const addTimeSlot = () => {
    setFormValues((prev) => ({
      ...prev,
      timeSlots: [...prev.timeSlots, { startTime: "", endTime: "" }],
    }));
  };

  const removeTimeSlot = (index) => {
    setFormValues((prev) => ({
      ...prev,
      timeSlots: prev.timeSlots.filter((_, i) => i !== index),
    }));
  };

  const updateTimeSlot = (index, field, value) => {
    setFormValues((prev) => ({
      ...prev,
      timeSlots: prev.timeSlots.map((slot, i) =>
        i === index ? { ...slot, [field]: value } : slot
      ),
    }));
  };

  const addCustomDate = () => {
    setFormValues((prev) => ({
      ...prev,
      customDates: [
        ...prev.customDates,
        { date: "", startTime: "", endTime: "" },
      ],
    }));
  };

  const removeCustomDate = (index) => {
    setFormValues((prev) => ({
      ...prev,
      customDates: prev.customDates.filter((_, i) => i !== index),
    }));
  };

  const updateCustomDate = (index, field, value) => {
    setFormValues((prev) => ({
      ...prev,
      customDates: prev.customDates.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  function generateScheduleTimeline(formValues, maxCount = 4) {
    const timeline = [];
    const freq = formValues.selectedTaskFrequencyName?.value;
    const scheduleDate = formValues.scheduleDate;
    const timeSlots = formValues.timeSlots || [];
    const repeatEvery = Number(
      formValues.selectedRepeatEvery?.value ||
        formValues.selectedRepeatEvery ||
        1
    );
    const endAfter =
      formValues.selectedEndAfterTimes?.value === "never"
        ? maxCount
        : Number(
            formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              maxCount
          );
    const weekdays = formValues.frequencyDays || [];
    const customDates = formValues.customDates || [];

    if (!freq || !scheduleDate) return timeline;

    if (freq === "no_repeat") {
      timeSlots.forEach((slot, idx) => {
        if (slot.startTime) {
          timeline.push({
            date: scheduleDate,
            time: slot.startTime,
            idx,
          });
        }
      });
      return timeline;
    }

    if (freq === "daily") {
      let date = moment(scheduleDate);
      let count = 0;
      while (count < endAfter) {
        timeSlots.forEach((slot) => {
          if (slot.startTime) {
            timeline.push({
              date: date.format("YYYY-MM-DD"),
              time: slot.startTime,
              idx: timeline.length,
            });
          }
        });
        count++;
        date = date.add(repeatEvery, "days");
      }
      return timeline;
    }

    if (freq === "hourly") {
      let date = moment(scheduleDate);
      let count = 0;
      while (count < endAfter) {
        timeSlots.forEach((slot) => {
          if (slot.startTime) {
            timeline.push({
              date: date.format("YYYY-MM-DD"),
              time: slot.startTime,
              idx: timeline.length,
            });
          }
        });
        count++;
        date = date.add(repeatEvery, "hours");
      }
      return timeline;
    }

    if (freq === "weekend") {
      let date = moment(scheduleDate);
      let count = 0;
      let weekStep = 0;
      const weekendDays = ["saturday", "sunday"];
      while (count < endAfter) {
        weekendDays.forEach((wd) => {
          const d = date.clone().day(wd);
          if (d.isBefore(date)) d.add(1, "week");
          if (count < endAfter) {
            timeSlots.forEach((slot) => {
              if (slot.startTime) {
                timeline.push({
                  date: d.format("YYYY-MM-DD"),
                  time: slot.startTime,
                  idx: timeline.length,
                });
              }
            });
            count++;
          }
        });
        weekStep++;
        date = moment(scheduleDate).add(weekStep * repeatEvery, "weeks");
      }
      return timeline.slice(0, endAfter);
    }

    if (freq === "week_days") {
      let date = moment(scheduleDate);
      let count = 0;
      let weekStep = 0;
      const weekdays = ["monday", "tuesday", "wednesday", "thursday", "friday"];
      while (count < endAfter) {
        weekdays.forEach((wd) => {
          const d = date.clone().day(wd);
          if (d.isBefore(date)) d.add(1, "week");
          if (count < endAfter) {
            timeSlots.forEach((slot) => {
              if (slot.startTime) {
                timeline.push({
                  date: d.format("YYYY-MM-DD"),
                  time: slot.startTime,
                  idx: timeline.length,
                });
              }
            });
            count++;
          }
        });
        weekStep++;
        date = moment(scheduleDate).add(weekStep * repeatEvery, "weeks");
      }
      return timeline.slice(0, endAfter);
    }

    if (freq === "weekly") {
      let date = moment(scheduleDate);
      let count = 0;
      let weekStep = 0;
      while (count < endAfter) {
        weekdays.forEach((wd) => {
          const d = date.clone().day(wd);
          if (d.isBefore(date)) d.add(1, "week");
          if (count < endAfter) {
            timeSlots.forEach((slot) => {
              if (slot.startTime) {
                timeline.push({
                  date: d.format("YYYY-MM-DD"),
                  time: slot.startTime,
                  idx: timeline.length,
                });
              }
            });
            count++;
          }
        });
        weekStep++;
        date = moment(scheduleDate).add(weekStep * repeatEvery, "weeks");
      }
      return timeline.slice(0, endAfter);
    }

    if (freq === "monthly") {
      let date = moment(scheduleDate);
      let count = 0;
      while (count < endAfter) {
        // Use the day of the month from scheduleDate
        const day = date.date();
        const month = date.month();
        const year = date.year();
        timeSlots.forEach((slot) => {
          if (slot.startTime) {
            timeline.push({
              date: moment({ year, month, day }).format("YYYY-MM-DD"),
              time: slot.startTime,
              idx: timeline.length,
            });
          }
        });
        count++;
        date = date.add(repeatEvery, "months");
      }
      return timeline;
    }

    if (freq === "yearly") {
      let date = moment(scheduleDate);
      let count = 0;
      while (count < endAfter) {
        timeSlots.forEach((slot) => {
          if (slot.startTime) {
            timeline.push({
              date: date.format("YYYY-MM-DD"),
              time: slot.startTime,
              idx: timeline.length,
            });
          }
        });
        count++;
        date = date.add(repeatEvery, "years");
      }
      return timeline;
    }

    if (freq === "custom") {
      customDates.forEach((item, idx) => {
        if (item.date && item.startTime) {
          timeline.push({ date: item.date, time: item.startTime, idx });
        }
      });
      return timeline;
    }

    return timeline;
  }
  // -------------- custom functions ----------------

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_hygiene_task : add_hygiene_task;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e) => {
    e?.preventDefault();

    const errors = validationHygieneNewTaskForm(formValues);
    setFormErrors(errors);
    setIsSubmit(true);

    if (formRef.current && Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors).find(
        (field) => formRef.current[field]
      );

      if (firstErrorField) {
        formRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  useEffect(() => {
    getHygieneTaskCategories();
  }, []);

  useEffect(() => {
    if (hygineTaskCategory?.status && hygineTaskCategory?.data?.length > 0) {
      const allCats = hygineTaskCategory.data?.map((item) => ({
        label: item?.name,
        value: item?.uid,
        info: item,
      }));

      setTaskCategories(allCats);
    } else {
      setTaskCategories([]);
    }
  }, [hygineTaskCategory]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const frequencyType = formValues.selectedTaskFrequencyName?.value;
      const accounts = formValues.selectedAccountTypes
        .map((item) => item?.value)
        .join(",");
      const medias =
        formValues.isImage && formValues.isVideo
          ? "image,video"
          : formValues.isImage
          ? "image"
          : formValues.isVideo
          ? "video"
          : null;

      const userData = {
        name: formValues.taskName || "",
        category: formValues.selectedHygineCategory?.value || "",
        priority: formValues.selectedTaskPriority?.value || "",
        stakeholders: accounts || "",
        frequency_type: frequencyType || "",
        media_required: formValues.isImage || formValues.isVideo ? 1 : 0,
        img_quantity: formValues.isImage ? formValues.imageQuantity : null,
        vid_quantity: formValues.isVideo ? formValues.videoQuantity : null,
        media_type: medias,
        description: formValues.taskDescription || "",
        status: formValues.isActive ? "active" : "inactive",

        scheduled_date: formValues.scheduleDate || "",
      };

      const getTimeValue = (timeValue) => {
        if (typeof timeValue === "string") return timeValue;
        if (timeValue?.value) return timeValue.value;
        return timeValue;
      };

      if (frequencyType === "custom") {
        userData.task_times = formValues.customDates.map((item) => ({
          date: item.date,
          start_time: getTimeValue(item.startTime),
          end_time: getTimeValue(item.endTime),
        }));
      } else if (frequencyType === "no_repeat") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
      } else if (frequencyType === "weekend") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.week = "saturday,sunday";
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      } else if (frequencyType === "week_days") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.week = "monday,tuesday,wednesday,thursday,friday";
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      } else if (frequencyType === "weekly") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.week = formValues.frequencyDays.map((item) => item).join(",");
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      } else if (frequencyType === "monthly") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.month_date_range = `${formValues.monthlyRangeStart},${formValues.monthlyRangeEnd}`;
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      } else if (frequencyType === "yearly") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      } else if (frequencyType === "hourly") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.task_times = [
          {
            start_time: getTimeValue(formValues.timeSlots[0].startTime),
            end_time: getTimeValue(formValues.timeSlots[0].endTime),
          },
        ];
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      } else if (frequencyType === "daily") {
        // userData.scheduled_date = formValues.scheduleDate;
        userData.task_times = formValues.timeSlots.map((slot) => ({
          start_time: getTimeValue(slot.startTime),
          end_time: getTimeValue(slot.endTime),
        }));
        userData.incremental_value =
          formValues.selectedRepeatEvery?.value ||
          formValues.selectedRepeatEvery ||
          "";
        userData.end_after =
          formValues.selectedEndAfterTimes?.value === "never"
            ? "-1"
            : formValues.selectedEndAfterTimes?.value ||
              formValues.selectedEndAfterTimes ||
              "";
      }

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      const confirmMessage = isEdit
        ? "Please review all the changes you've made to this task. Once updated, the task schedule and assignments will be modified accordingly. Are you sure you want to update this task?"
        : "Please review all the task details before submitting. Once created, this task will be assigned to the selected stakeholders and will follow the configured schedule. Are you sure you want to create this task?";

      showConfirmAlert(
        handleConfirm,
        confirmMessage,
        "Confirm",
        `${isEdit ? "Update" : "Add"} Task`
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "schedule_summary" ? (
          <div
            className="createNewCTOModalContainer mod-width-50p"
            style={{ padding: 24 }}
          >
            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 8 }}>
              Time Cards
            </div>
            <div style={{ borderBottom: "1px solid #eee", marginBottom: 16 }} />
            <div>
              {generateScheduleTimeline(formValues).map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#bdbdbd",
                    marginBottom: 12,
                  }}
                >
                  {i === 0 ? <ClockIconV3 /> : <RightArrowIcon />}
                  <span style={{ marginLeft: 10 }}>
                    {i + 1}.{" "}
                    {moment(
                      item.date + " " + item.time,
                      "YYYY-MM-DD HH:mm"
                    ).format("ddd, MMM DD, YYYY - hh:mm a")}
                  </span>
                </div>
              ))}
            </div>
            <div style={{ borderBottom: "1px solid #eee", margin: "16px 0" }} />
            <div style={{ textAlign: "right" }}>
              <button
                type="button"
                onClick={onCloseModal}
                style={{
                  background: "none",
                  border: "none",
                  color: "#2d7ff9",
                  fontWeight: 700,
                  fontSize: 18,
                  cursor: "pointer",
                }}
              >
                DONE
              </button>
            </div>
          </div>
        ) : (
          <TaskCategoryForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => getHygieneTaskCategories()}
          />
        )}
      </Modal>

      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Task`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Submit"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label
              htmlFor="selectedHygineCategory"
              className={`formInputLabel`}
            >
              task category <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Select the category this task belongs to. Categories help organize
              and group similar tasks together. If you don't see the category
              you need, click{" "}
              <span className="doc-tasks-info-highlight">Add New</span> to
              create one.
            </p>

            <div className="input-add-btn flexBetween">
              <div
                className={`commonWrapper ${
                  formErrors.selectedHygineCategory ? "formError" : ""
                }`}
                ref={assignRef("selectedHygineCategory")}
              >
                <SelectDropdown
                  options={taskCategories}
                  selectedOption={formValues.selectedHygineCategory}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedHygineCategory")
                  }
                  name="Task Category"
                />
              </div>

              <button
                type="button"
                className="btn btn-dark extraBtn"
                style={{
                  minWidth: "150px",
                  height: "60px",
                  textTransform: "capitalize",
                }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "add",
                  }))
                }
              >
                Add New
              </button>
            </div>
            <span className="error-label">
              {formErrors?.selectedHygineCategory || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="taskName" className={`formInputLabel `}>
              task name <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Enter a clear, descriptive name for this task (e.g., "Clean
              Reception Area", "Check Equipment"). Keep it concise and specific.
            </p>

            <input
              type="text"
              placeholder="Name"
              className={`formInput ${formErrors?.taskName ? "formError" : ""}`}
              name="taskName"
              value={formValues.taskName}
              onChange={onChangeInput}
              min={currentDateOfTheMonth}
              ref={assignRef("taskName")}
            />
            <span className="error-label">{formErrors?.taskName || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedTaskPriority" className="formInputLabel">
              Task priority <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Set the urgency level for this task.{" "}
              <span className="doc-tasks-info-highlight">High</span> priority
              tasks should be completed first, followed by Medium and Low.
            </p>

            <div
              className={`commonWrapper ${
                formErrors.selectedTaskPriority ? "formError" : ""
              }`}
              ref={assignRef("selectedTaskPriority")}
            >
              <SelectDropdown
                options={TASK_PRIORITY}
                selectedOption={formValues.selectedTaskPriority}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedTaskPriority")
                }
                name="task priority"
              />
            </div>
            <span className="error-label">
              {formErrors?.selectedTaskPriority || ""}
            </span>
          </div>

          <div className="formInputBox multi-select-wrapper">
            <label htmlFor="selectedAccountTypes" className="formInputLabel">
              stakeholders <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Select who should be responsible for completing this task. You can
              choose multiple stakeholders if needed.
            </p>

            <div
              className={`commonWrapper no-border multi-select ${
                formErrors.selectedAccountTypes ? "error" : ""
              }`}
              ref={assignRef("selectedAccountTypes")}
            >
              <MultiSelect
                options={[
                  {
                    label: "Trainer",
                    value: "trainer",
                  },
                  {
                    label: "Receptionist",
                    value: "receptionist",
                  },
                ]}
                state={formValues.selectedAccountTypes}
                setState={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedAccountTypes")
                }
                name="select stakeholders"
                isDisable={postPutLoading}
              />
            </div>
            <span className="error-label">
              {formErrors?.selectedAccountTypes || ""}
            </span>
          </div>
        </div>

        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label
              htmlFor="selectedTaskFrequencyName"
              className={`formInputLabel `}
            >
              frequncy type <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Choose how often this task should repeat.{" "}
              <span className="doc-tasks-info-highlight">No Repeat</span> for
              one-time tasks,{" "}
              <span className="doc-tasks-info-highlight">
                Daily/Weekly/Monthly
              </span>{" "}
              for recurring tasks, or{" "}
              <span className="doc-tasks-info-highlight">Custom</span> for
              specific dates.
            </p>

            <div
              className={`commonWrapper ${
                formErrors?.selectedTaskFrequencyName ? "formError" : ""
              }`}
              ref={assignRef("selectedTaskFrequencyName")}
            >
              <SelectDropdown
                options={hygine_task_frequency_categories}
                selectedOption={formValues.selectedTaskFrequencyName}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedTaskFrequencyName")
                }
                name="Type"
                preventKeyboardOpen={true}
              />
            </div>
            <span className="error-label">
              {formErrors?.selectedTaskFrequencyName || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="scheduleDate" className="formInputLabel">
              Schedule Date <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Select the starting date for this task. For recurring tasks, this
              will be the first occurrence date.
            </p>

            <input
              type="date"
              placeholder="Schedule Date"
              className={`formInput ${
                formValues.scheduleDate ? "date-has-value" : ""
              } ${formErrors?.scheduleDate ? "formError" : ""}`}
              name="scheduleDate"
              value={formValues.scheduleDate}
              onChange={onChangeInput}
              min={currentDateOfTheMonth}
              ref={assignRef("scheduleDate")}
            />
            <span className="error-label">
              {formErrors?.scheduleDate || ""}
            </span>

            {/* Several times per day checkbox - enabled except for hourly and custom */}
            {formValues.selectedTaskFrequencyName?.value &&
              formValues.selectedTaskFrequencyName.value !== "hourly" &&
              formValues.selectedTaskFrequencyName.value !== "custom" && (
                <Form.Check
                  type="checkbox"
                  name="isMultipleTimes"
                  className={`${
                    formErrors?.isMultipleTimes ? "formError" : ""
                  }`}
                  style={{
                    cursor:
                      formValues.selectedTaskFrequencyName.value === "hourly"
                        ? "not-allowed"
                        : "pointer",
                  }}
                  label="several times per day"
                  checked={formValues.isMultipleTimes}
                  onChange={onChangeInput}
                  disabled={
                    formValues.selectedTaskFrequencyName.value === "hourly"
                  }
                />
              )}
          </div>

          {/* Start and end time - hidden for custom frequency type */}
          {formValues.selectedTaskFrequencyName?.value !== "custom" && (
            <div
              className={`formInputBox multi-removable-inputs ${
                formValues.isMultipleTimes && formValues.timeSlots?.length > 1
                  ? "span2"
                  : ""
              }`}
            >
              <label htmlFor="startTime" className="formInputLabel">
                start and end time <span className="required">*</span>
              </label>
              <p className="doc-tasks-info">
                Set the time window for task completion. For tasks that occur
                multiple times per day, check{" "}
                <span className="doc-tasks-info-highlight">
                  "several times per day"
                </span>{" "}
                and add more time slots.
              </p>

              <div className="wrapper-inputs" ref={assignRef("timeSlots")}>
                {formValues.timeSlots?.map((slot, index) => (
                  <div
                    key={index}
                    className={`flex-box wrapped-inputs ${
                      formErrors.timeSlots && formErrors.timeSlots[index]
                        ? "formError"
                        : ""
                    }`}
                  >
                    <div className={`enter-value commonWrapper`}>
                      <SelectDropdownLabel
                        options={timeOptions}
                        selectedOption={slot.startTime}
                        setSelectedOption={(selectedValue) =>
                          updateTimeSlot(index, "startTime", selectedValue)
                        }
                        name="start time"
                      />
                    </div>

                    <div className={`enter-value commonWrapper`}>
                      <SelectDropdownLabel
                        options={timeOptions}
                        selectedOption={slot.endTime}
                        setSelectedOption={(selectedValue) =>
                          updateTimeSlot(index, "endTime", selectedValue)
                        }
                        name="end time"
                      />
                    </div>

                    {index > 0 && (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeTimeSlot(index)}
                        style={{ marginLeft: "10px" }}
                      >
                        X
                      </button>
                    )}

                    {formValues.isMultipleTimes &&
                      formValues.timeSlots?.length - 1 === index && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => addTimeSlot()}
                          style={{ marginLeft: "10px" }}
                        >
                          <Plus color="#fff" />
                        </button>
                      )}
                  </div>
                ))}
              </div>
              <span className="error-label">
                {formErrors?.timeSlots &&
                typeof formErrors.timeSlots === "string"
                  ? formErrors.timeSlots
                  : ""}
              </span>
            </div>
          )}

          {/* Monthly frequency: date range selection */}
          {formValues.selectedTaskFrequencyName?.value === "monthly" && (
            <div className="formInputBox multi-removable-inputs">
              <label className="formInputLabel">
                choose date range (in month) <span className="required">*</span>
              </label>
              <p className="doc-tasks-info">
                Select a date range within the same month. This defines the
                period during which the task should be completed each month.{" "}
                <span className="doc-tasks-info-highlight">
                  Both dates must be from the same month.
                </span>
              </p>

              <div className="wrapper-inputs">
                <div
                  className={`flex-box wrapped-inputs ${
                    formErrors.monthlyRangeStart && formErrors.monthlyRangeStart
                      ? "formError"
                      : ""
                  }`}
                  style={{ marginBottom: "10px" }}
                  ref={assignRef("monthlyRangeStart")}
                >
                  <div className="enter-value commonWrapper">
                    <input
                      type="date"
                      className={`formInput  ${
                        formValues.monthlyRangeStart ? "date-has-value" : ""
                      }`}
                      value={formValues.monthlyRangeStart}
                      onChange={onChangeInput}
                      name="monthlyRangeStart"
                      min={currentDateOfTheMonth}
                    />
                  </div>

                  <div className="enter-value commonWrapper">
                    <input
                      type="date"
                      className={`formInput  ${
                        formValues.monthlyRangeEnd ? "date-has-value" : ""
                      }`}
                      value={formValues.monthlyRangeEnd}
                      onChange={onChangeInput}
                      name="monthlyRangeEnd"
                      min={currentDateOfTheMonth}
                    />
                  </div>
                </div>
              </div>
              <span className="error-label">
                {formErrors?.monthlyRangeStart || ""}
              </span>
            </div>
          )}

          {/* {formValues.selectedTaskFrequencyName?.value === "daily_hourly" && (
            <div className="formInputBox">
              <label
                htmlFor="selectedFrequencyInterval"
                className={`formInputLabel `}>
                time interval <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedFrequencyInterval ? "formError" : ""
                }`}>
                <SelectDropdown
                  options={generateNumberObjects()}
                  selectedOption={formValues.selectedFrequencyInterval}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedFrequencyInterval")
                  }
                  name=""
                />
              </div>
            </div>
          )} */}

          {/* {formValues.selectedTaskFrequencyName?.value === "yearly" && (
            <div className="formInputBox">
              <label htmlFor="selectedMonth" className={`formInputLabel `}>
                month <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedMonth ? "formError" : ""
                }`}>
                <SelectDropdown
                  options={months}
                  selectedOption={formValues.selectedMonth}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedMonth")
                  }
                  name="Select"
                />
              </div>
            </div>
          )} */}

          {/* {(formValues.selectedTaskFrequencyName?.value === "monthly" ||
            formValues.selectedTaskFrequencyName?.value === "yearly") && (
            <div className="formInputBox">
              <label htmlFor="frequencyDate" className={`formInputLabel `}>
                date <span className="required">*</span>
              </label>

              <input
                type="date"
                placeholder="Date"
                className={`formInput ${
                  formErrors?.frequencyDate ? "formError" : ""
                } ${formValues.frequencyDate ? "date-has-value" : ""}`}
                name="frequencyDate"
                value={formValues.frequencyDate}
                onChange={onChangeInput}
                min={selectedMonthRange?.min}
                max={selectedMonthRange?.max}
              />
            </div>
          )} */}

          {formValues.selectedTaskFrequencyName?.value === "weekly" && (
            <div className="formInputBox checkbox-wrapper span2">
              <label htmlFor="frequencyDays" className="formInputLabel">
                choose days <span className="required">*</span>
              </label>
              <p className="doc-tasks-info">
                Select which days of the week this task should occur. You can
                choose multiple days for tasks that need to be done on specific
                weekdays.
              </p>

              <div
                className={`flex-box ${
                  formErrors?.frequencyDays ? "formError" : ""
                }`}
                style={{
                  padding: formErrors?.frequencyDays ? "15px" : "",
                  borderRadius: "10px",
                }}
                ref={assignRef("frequencyDays")}
              >
                {daysOfWeek.map((day) => (
                  <label key={day.value} className="checkboxLabel">
                    <input
                      type="checkbox"
                      value={day.value}
                      checked={formValues.frequencyDays.includes(day.value)}
                      onChange={() => handleCheckboxChange(day.value)}
                    />
                    {day.label}
                  </label>
                ))}
              </div>
              <span className="error-label">
                {formErrors?.frequencyDays || ""}
              </span>
            </div>
          )}

          {formValues.selectedTaskFrequencyName?.value === "custom" && (
            <div
              className={`formInputBox multi-removable-inputs span2 ${
                formErrors?.frequencyDate ? "formError" : ""
              }`}
            >
              <label className="formInputLabel">
                Custom Dates & Times <span className="required">*</span>
              </label>
              <p className="doc-tasks-info">
                Define specific dates and time slots for this task. This is
                useful for tasks that don't follow a regular pattern. Click{" "}
                <span className="doc-tasks-info-highlight">+</span> to add more
                custom date/time combinations.
              </p>

              <div className="wrapper-inputs" ref={assignRef("customDates")}>
                {(formValues.customDates || []).map((item, index) => (
                  <div
                    key={index}
                    className={`flex-box wrapped-inputs ${
                      formErrors.customDates && formErrors.customDates[index]
                        ? "formError"
                        : ""
                    }`}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className="enter-value commonWrapper">
                      <input
                        type="date"
                        className={`formInput  ${
                          item.date ? "date-has-value" : ""
                        }`}
                        value={item.date}
                        onChange={(e) =>
                          updateCustomDate(index, "date", e.target.value)
                        }
                        min={currentDateOfTheMonth}
                      />
                    </div>

                    <div className="enter-value commonWrapper">
                      <SelectDropdownLabel
                        options={timeOptions}
                        selectedOption={item.startTime}
                        setSelectedOption={(selectedValue) =>
                          updateCustomDate(index, "startTime", selectedValue)
                        }
                        name="start time"
                      />
                    </div>

                    <div className="enter-value commonWrapper">
                      <SelectDropdownLabel
                        options={timeOptions}
                        selectedOption={item.endTime}
                        setSelectedOption={(selectedValue) =>
                          updateCustomDate(index, "endTime", selectedValue)
                        }
                        name="end time"
                      />
                    </div>

                    {index > 0 && (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeCustomDate(index)}
                        style={{ marginLeft: "10px" }}
                      >
                        X
                      </button>
                    )}
                    {index === (formValues.customDates || []).length - 1 && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addCustomDate}
                        style={{ marginLeft: "10px" }}
                      >
                        <Plus color="#fff" />
                      </button>
                    )}
                  </div>
                ))}
              </div>
              <span className="error-label">
                {formErrors?.customDates &&
                typeof formErrors.customDates === "string"
                  ? formErrors.customDates
                  : ""}
              </span>
            </div>
          )}
        </div>

        <div className="formInputsGrid twoGridSystem">
          {formValues.selectedTaskFrequencyName?.value &&
            formValues.selectedTaskFrequencyName.value !== "no_repeat" &&
            formValues.selectedTaskFrequencyName.value !== "custom" && (
              <>
                <div className="formInputBox">
                  <label className="formInputLabel">
                    Repeat every ({getRepeatEveryLabel()}){" "}
                    <span className="required">*</span>
                  </label>
                  <p className="doc-tasks-info">
                    Set the interval for task repetition. For example,{" "}
                    <span className="doc-tasks-info-highlight">"2"</span> for
                    daily means every 2 days,{" "}
                    <span className="doc-tasks-info-highlight">"3"</span> for
                    weekly means every 3 weeks.
                  </p>
                  <div
                    className={`commonWrapper ${
                      formErrors?.selectedRepeatEvery ? "formError" : ""
                    }`}
                    ref={assignRef("selectedRepeatEvery")}
                  >
                    <SelectDropdown
                      options={repeatEveryOptions}
                      selectedOption={formValues.selectedRepeatEvery}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedRepeatEvery")
                      }
                      name={getRepeatEveryLabel()}
                    />
                  </div>
                  <span className="error-label">
                    {formErrors?.selectedRepeatEvery || ""}
                  </span>
                </div>

                <div className="formInputBox">
                  <label className="formInputLabel">
                    End after (times) <span className="required">*</span>
                  </label>
                  <p className="doc-tasks-info">
                    Specify how many times the task should occur before
                    stopping. Select{" "}
                    <span className="doc-tasks-info-highlight">"Never"</span>{" "}
                    for tasks that continue indefinitely.
                  </p>
                  <div
                    className={`commonWrapper ${
                      formErrors?.selectedEndAfterTimes ? "formError" : ""
                    }`}
                    ref={assignRef("selectedEndAfterTimes")}
                  >
                    <SelectDropdown
                      options={endAfterOptions}
                      selectedOption={formValues.selectedEndAfterTimes}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedEndAfterTimes")
                      }
                      name=""
                    />
                  </div>
                  <span className="error-label">
                    {formErrors?.selectedEndAfterTimes || ""}
                  </span>
                </div>
              </>
            )}
        </div>

        <div className="formInputsGrid">
          {/* View Schedule Summary Button */}
          {/* <div
            className="formInputBox span3"
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "16px",
            }}
          >
            <button
              type="button"
              className="view-schedule-summary-btn"
              style={{
                display: "flex",
                alignItems: "center",
                background: "#eaf3ff",
                color: "#2d7ff9",
                border: "none",
                borderRadius: "12px",
                padding: "12px 24px",
                fontWeight: 600,
                fontSize: "16px",
                cursor: "pointer",
                gap: "10px",
                width: "100%",
                justifyContent: "center",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "schedule_summary",
                }))
              }
            >
              <CalendarIcon />
              View Schedule Summary
            </button>
          </div> */}

          <div className="formInputBox span3">
            <label htmlFor="taskDescription" className="formInputLabel">
              Task description <span className="required">*</span>
            </label>
            <p className="doc-tasks-info">
              Provide detailed instructions for completing this task. Include
              what needs to be done, any specific requirements, and expected
              outcomes. Be clear and specific to help stakeholders understand
              the task.
            </p>

            <textarea
              name="taskDescription"
              className={`formInput ${
                formErrors.taskDescription && "formError"
              }`}
              style={{ minHeight: "150px" }}
              placeholder="Enter Details"
              value={formValues.taskDescription}
              onChange={onChangeInput}
              ref={assignRef("taskDescription")}
            ></textarea>
            <span className="error-label">
              {formErrors?.taskDescription || ""}
            </span>
          </div>

          {formValues.isImage && (
            <div className="formInputBox">
              <label htmlFor="imageQuantity" className={`formInputLabel`}>
                image quantity <span className="required">*</span>
              </label>
              <p className="doc-tasks-info">
                Specify how many images are required as proof of task
                completion.
              </p>

              <input
                type="number"
                placeholder="Quantity"
                className={`formInput ${
                  formErrors?.imageQuantity ? "formError" : ""
                }`}
                name="imageQuantity"
                value={formValues.imageQuantity}
                onChange={onChangeInput}
                ref={assignRef("imageQuantity")}
              />
              <span className="error-label">
                {formErrors?.imageQuantity || ""}
              </span>
            </div>
          )}

          {formValues.isVideo && (
            <div className="formInputBox">
              <label htmlFor="videoQuantity" className={`formInputLabel`}>
                video quantity <span className="required">*</span>
              </label>
              <p className="doc-tasks-info">
                Specify how many videos are required as proof of task
                completion.
              </p>

              <input
                type="number"
                placeholder="Quantity"
                className={`formInput ${
                  formErrors?.videoQuantity ? "formError" : ""
                }`}
                name="videoQuantity"
                value={formValues.videoQuantity}
                onChange={onChangeInput}
                ref={assignRef("videoQuantity")}
              />
              <span className="error-label">
                {formErrors?.videoQuantity || ""}
              </span>
            </div>
          )}

          <div className="formInputBox checkbox-wrapper span3">
            <p className="doc-tasks-info" style={{ marginBottom: "8px" }}>
              <span className="doc-tasks-info-highlight">
                Media Requirements:
              </span>{" "}
              Check if images or videos are required for task verification.{" "}
              <span className="doc-tasks-info-highlight">Active:</span> Enable
              this to make the task available for assignment immediately.
            </p>
            <div className={`flex-box`}>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isImage"
                  checked={formValues.isImage}
                  onChange={onChangeInput}
                />
                Image
              </label>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isVideo"
                  checked={formValues.isVideo}
                  onChange={onChangeInput}
                />
                Video
              </label>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                Active
              </label>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default TaskForm;
